module.exports = __webpack_public_path__ + "static/media/manage-categories.1164de87.svg";